import {
  STORE_SET,
  STORES_SET,
  STORE_SET_SAVED,
  SYNC_FAILED,
  SYNC_FINISHED,
  SYNC_INITIATED,
} from './actionTypes';
import {
  IFailedSyncAction,
  IStoresAction,
  IStoresState,
  ISetStoreAction,
  ISetStoresAction,
} from './types';

// @TODO retrieve the possible statuses from the server when they will be available
export const initialState = {
  error: null,
  loaded: false,
  statuses: [
    { key: 'ACTIVE', value: 'ACTIVE' },
    { key: 'INACTIVE', value: 'INACTIVE' },
  ],
  stores: [],
  syncing: 0,
  storeSaved: false,
};

export const reducer = (
  state: IStoresState = initialState,
  action: IStoresAction
): IStoresState => {
  switch (action.type) {
    case SYNC_INITIATED:
      return { ...state, error: null, syncing: state.syncing + 1, storeSaved: false };
    case SYNC_FINISHED:
      return { ...state, syncing: state.syncing - 1 };
    case STORE_SET_SAVED:
      return { ...state, storeSaved: true };
    case STORE_SET:
      const storeIndex = state.stores.findIndex(
        (store) => store.enterpriseUnitId === (action as ISetStoreAction).payload.enterpriseUnitId
      );
      return {
        ...state,
        stores: [
          ...state.stores.slice(0, storeIndex),
          (action as ISetStoreAction).payload,
          ...state.stores.slice(storeIndex + 1),
        ],
      };
    case STORES_SET:
      return {
        ...state,
        loaded: true,
        stores: (action as ISetStoresAction).payload,
      };
    case SYNC_FAILED:
      return { ...state, error: (action as IFailedSyncAction).payload };
    default:
      return state;
  }
};
